export default class extends Controller {
  static targets = ["targetLanguage"];

  connect() {
    if (document.getElementById('allow_translation').value=== 'true'){
      this.loadSelectedLanguage();
      if (document.getElementById('default_language').value !=  localStorage.getItem('selectedLanguage') || document.getElementById('default_language').value != 'en'){
        this.translateAllText();
      }
    }
  }

  loadSelectedLanguage() {
    const selectedLanguage = localStorage.getItem('selectedLanguage')
    if (selectedLanguage) {
      this.targetLanguageTarget.value = selectedLanguage
    }
  }

  saveSelectedLanguage() {
    if (document.getElementById('allow_translation').value === 'true'){
      const selectedLanguage = this.targetLanguageTarget.value
      localStorage.setItem('selectedLanguage', selectedLanguage)
    }
  }

  translateAllText() {
    if (document.getElementById('allow_translation').value === 'true'){
      var path = window.location.pathname.split('/')[1]
      const targetLanguage = (path === 'chats') ? 'en' : this.targetLanguageTarget.value;

      // Select all text nodes within the body element
      const textNodes = this.getTextNodes(document.body);
      const textsToTranslate = textNodes.map(node => node.textContent.trim());
      this.translateTexts(textsToTranslate, targetLanguage);
    }
  }

  getTextNodes(node) {
    const textNodes = [];
    if (node.nodeType === Node.TEXT_NODE) {
      textNodes.push(node);
    }else {
      var children = Array.from(node.childNodes).filter(childNode => {
            return !(childNode.nodeName === 'SCRIPT') &&
                   !(childNode.nodeName === 'DIV' && childNode.classList.contains('intercom-lightweight-app')) &&
                   !(childNode.nodeName === 'DIV' && childNode.id === 'translate-div') &&
                   !(childNode.nodeName === 'DIV' && childNode.classList.contains('upload-icons')) &&
                   !(childNode.nodeName === 'DIV' && childNode.classList.contains('emoji-picker'));
        });
      for (let i = 0; i < children.length; i++) {
        textNodes.push(...this.getTextNodes(children[i]));
      }
    }
    return textNodes;
  }

  translateTexts(textsToTranslate, targetLanguage) {
    fetch("/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ texts: textsToTranslate, target_language: targetLanguage })
    })
    .then(response => response.json())
    .then(data => {
      this.updateTranslatedTexts(data.translated_texts);
    })
  }

  updateTranslatedTexts(translations) {
    const textNodes = this.getTextNodes(document.body);
    textNodes.forEach((node, index) => {
      node.textContent = translations[index];
    });
    const emojiButtons = document.querySelectorAll('.emoji-picker__emoji');

    emojiButtons.forEach((button, index) => {
      const emoji = button.getAttribute('data-emoji');
      button.textContent = emoji;
    });
  }
}
